export const AttachmentMap = {
  AUTO: 'auto',
  TOP: 'top-start',
  TOPEND: 'top-end',
  BOTTOM: 'bottom-start',
  BOTTOMEND: 'bottom-end'
}



// WEBPACK FOOTER //
// ./src/constants.js